import * as React from 'react';

import {
  goToOrders,
  goToInvoices,
  goToTracking,
  goToReturns,
  ifLoggedIn,
  invoicesUrl,
  returnsUrl,
  trackingUrl,
  ordersUrl,
  goToLists,
  listsUrl,
  goToWarranty,
  returnsWarrantUrl
} from 'src/utils/navigation';
import './MyOrdersMenu.scss';
import orderIcon from 'src/assets/myOrderIcon';
import orders from 'src/assets/ordersIcon';
import invoice from 'src/assets/invoiceIcon';
import tracking from 'src/assets/myTrackIcon';
import returnIcon from 'src/assets/returnIcon';
import claimIcon from 'src/assets/ClaimIcon';
import starIcon from 'src/assets/star-icon';
import { env } from 'src/shared/env';

interface IMyOrdersMenuState {
  floatingIsOpen: boolean;
}

interface IMyOrdersMenuProps {
  isLoggedIn: boolean;
}

export default class MyOrdersMenu extends React.Component<
  any,
  IMyOrdersMenuState
> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false
    };
  }

  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private goToOrders = () => ifLoggedIn(() => goToOrders());
  private goToInvoices = () => ifLoggedIn(() => goToInvoices());
  private goToTracking = () => ifLoggedIn(() => goToTracking());
  private goToReturns = () => ifLoggedIn(() => goToReturns());
  private goToWarranty = () => ifLoggedIn(() => goToWarranty());
  private gotToLists = () => ifLoggedIn(() => goToLists());

  public render() {
    const { t } = this.props;
    const menuState = this.state.floatingIsOpen ? 'opened' : '';

    return (
      <div
        id="my-orders-menu" className="my-more-menu"
        onMouseOut={this.closeMenu}
        onMouseOver={this.openMenu}
        onKeyDown={(event:any) => {
          if(event.keyCode === 13) {
            this.openMenu();
          } 
        }}
      >
        <div
          className="my-orders-menu--my-account"
          onClick={this.handleMenuState}
        >
          <div className="my-orders-menu--info">
            <img src={orderIcon} alt="your order" className="your-order-icon" />
            <div role="button" tabIndex={0}  className="go-to-account">
              <p className="my-account">{t('menu.myOrders')}</p>
            </div>
          </div>
        </div>
        <div
          className={`my-orders-menu--my-account--fly-menu ${menuState}`}
          ref={ref => (this.flyMenuRef = ref)}
        >
          <p className="menu-item-heading">{t('menu.myOrders')}</p>
          <a
            href={ordersUrl()}
            className="menu-item menu-link"
            onClick={this.goToOrders}
          >
            <img src={orders} alt="icon" className="menu-item-icon" />
            {t('menu.myOrders')}
          </a>
          <a
            href={invoicesUrl()}
            className="menu-item menu-link"
            onClick={this.goToInvoices}
          >
            <img src={invoice} alt="icon" className="menu-item-icon" />
            {t('menu.myInvoices')}
          </a>
          {/* <a
            href={trackingUrl()}
            className="menu-item menu-link"
            onClick={this.goToTracking}
          >
            <img src={tracking} alt="icon" className="menu-item-icon" />
            {t('menu.myTracking')}
          </a> */}
          <a
            href={this.props.isLoggedIn && returnsUrl()}
            className="menu-item menu-link"
            onClick={this.goToReturns}
          >
            <img src={returnIcon} alt="icon" className="menu-item-icon" />
            {t('menu.myReturns')}
          </a>
          <a
            href={this.props.isLoggedIn && returnsWarrantUrl()}
            className="menu-item menu-link"
            onClick={this.goToWarranty}
          >
            <img src={claimIcon} alt="icon" className="menu-item-icon" />
            {t('menu.myWarranty')}
          </a>
          <a
            href={this.props.isLoggedIn && listsUrl()}
            className="menu-item menu-link"
            onClick={this.gotToLists}
          >
            <img src={starIcon} alt="icon" className="menu-item-icon" />
            {/* {t('myFavourites.breadCrumb')} */}
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? t('myFavourites.breadCrumbCA')
              : t('myFavourites.breadCrumb')}
          </a>
        </div>
      </div>
    );
  }
}
